import React from 'react';
import cx from 'classnames';
import styles from './Card.module.scss';
import type { CardProps } from './Card.types';

/**
 * Card component definition.
 */
const Card = (props: CardProps) => {
  const { className, children } = props;
  return <div className={cx(styles.card, className)}>{children}</div>;
};

export default Card;
